import {bookingUpdateDatesConstants} from "../../../../constants/General/bookingUpdateDates.constants";

const initialState = {
    fetching: false,
    data: null,
    error: false,
};

export default function (state = initialState, action) {
    switch (action.type) {

        case bookingUpdateDatesConstants.BOOKING_UPDATE_DATES_PENDING:
            return {
                ...state,
                fetching: true,
                data: null,
                error: false,
            };
        case bookingUpdateDatesConstants.BOOKING_UPDATE_DATES_FULFILLED:
            return {
                ...state,
                fetching: false,
                error: false,
                data: action.payload,
            };
        case bookingUpdateDatesConstants.BOOKING_UPDATE_DATES_REJECTED:
            return {
                ...state,
                fetching: false,
                error: action.payload,
            };

        case bookingUpdateDatesConstants.BOOKING_UPDATE_DATES_CLEAR:
            return {
                ...initialState,
            };
        case "CLEAR_STATE":
            return {
                ...initialState,
            };
        default:
            return state;
    }
}
